import { render, staticRenderFns } from "./AssignedTeachersEditModal.vue?vue&type=template&id=0c05d821&scoped=true&"
import script from "./AssignedTeachersEditModal.vue?vue&type=script&lang=js&"
export * from "./AssignedTeachersEditModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignedTeachersEditModal.vue?vue&type=style&index=0&id=0c05d821&prod&scoped=true&lang=css&"
import style1 from "./AssignedTeachersEditModal.vue?vue&type=style&index=1&id=0c05d821&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05d821",
  null
  
)

export default component.exports